module.exports = __webpack_public_path__ + "5d8a640b4f155e67255ff07f45cd4464.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img1_2.jpg
// module id = 536
// module chunks = 0